/**
 * Vuex "alerts" module (registered as `notifications` in the root store).
 *
 * Aggregates in-app notification state: unread/read notification lists and
 * counts, load status, and fetch-error messages. State (store.js) is written
 * by mutations (updates.js), which are committed by actions (operations.js)
 * that talk to the notifications API; getters (selectors.js) expose it all
 * to components (e.g. the notifications bell/list).
 */
import state from "./store";
import mutations from "./updates";
import getters from "./selectors";
import actions from "./operations";

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
